import React, { useState, useRef, useEffect } from "react";
import "./../Steps.scss";
import { Button, Form, Select, Checkbox } from "antd";
import { useMediaQuery } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import deleteIcon from "../../../../assets/images/png/delete_icon.png";
import { APIV3 } from "../../../../utils/customAxios";
import addIcon from "../../../../assets/images/svg/newDesign/addIcon.svg";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getUniversities } from "../../../../pages/updateProfile/redux/thunk";
import { selectUniversities } from "../../../../pages/updateProfile/redux/slice";

const { Option } = Select;

let index = 0;
function Experiance(props) {
  const {
    experienceRowCount,
    duplicateExperienceRow,
    deleteExperienceRow,
    rowCertificate,
    duplicateRowCertificate,
    deleteRowCertificate,
    form,
    isCurrentlyWorking,
    setIsCurrentlyWorking,
    experienceForm,
  } = props;
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery("(max-width:767px)");
  const [designations, setDesignations] = useState([]);
  const universities = useAppSelector(selectUniversities);
  const [certifications, setCertifications] = useState([]);

  const inputRef = useRef(null);

  useEffect(() => {
    dispatch(getUniversities());
  }, []);

  useEffect(() => {
    APIV3.get("/doctor/designation").then((res) => {
      if (res?.status == 200) {
        setDesignations(res?.data?.data);
      }
    });
  }, []);

  useEffect(() => {
    APIV3.get("/doctor/certifications").then((res) => {
      if (res?.status == 200) {
        setCertifications(res?.data?.data);
      }
    });
  }, []);

  const currentYear = new Date().getFullYear();
  const startYear = 1980;
  // const years = [];

  const years = Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i);

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year.toString());
  }

  const validateStartEndYear = (_, value, callback) => {
    const startYear = value;
    const endYear = form.getFieldValue(`endyear${index + 1}`);

    if (startYear && endYear && startYear > endYear) {
      callback("Start year cannot be later than end year");
    } else {
      callback();
    }
  };

 async function currentlyWorkingHandler(e, id) {
  try {
    const updated = [...isCurrentlyWorking];
    updated[id] = e.target.checked;
    setIsCurrentlyWorking(updated);

    if (e.target.checked) {
      form.setFieldsValue({
        [`endyear${id + 1}`]: undefined,
        [`endmonth${id + 1}`]: undefined,
      });
    }
    
    // Trigger validation for current and adjacent experiences
    setTimeout(() => {
      // Validate current experience
      form.validateFields([
        `startyear${id + 1}`,
        `endyear${id + 1}`,
        `startmonth${id + 1}`,
        `endmonth${id + 1}`
      ]);
      
      // Validate previous experience if exists
      if (id > 0) {
        form.validateFields([
          `endyear${id}`,
          `endmonth${id}`
        ]);
      }
      
      // Validate next experience if exists
      if (id < experienceRowCount - 1) {
        form.validateFields([
          `startyear${id + 2}`,
          `startmonth${id + 2}`
        ]);
      }
    }, 100);
  } catch (error) {
    console.error("Error handling currently working checkbox:", error);
  }
}

    
  const months = [
    { id: 1, name: 'January' }, { id: 2, name: 'February' }, 
    { id: 3, name: 'March' }, { id: 4, name: 'April' },
    { id: 5, name: 'May' }, { id: 6, name: 'June' },
    { id: 7, name: 'July' }, { id: 8, name: 'August' },
    { id: 9, name: 'September' }, { id: 10, name: 'October' },
    { id: 11, name: 'November' }, { id: 12, name: 'December' }
  ];

const validateExperienceDates = (_, value, index) => {
  // Get current experience dates
  const startMonth = form.getFieldValue(`startmonth${index + 1}`);
  const startYear = value;
  const endMonth = form.getFieldValue(`endmonth${index + 1}`);
  const endYear = form.getFieldValue(`endyear${index + 1}`);
  const isCurrent = isCurrentlyWorking[index];

  // Skip validation if currently working and no end date
  if (isCurrent && !endYear) {
    return Promise.resolve();
  }

  // Validate current experience
  if (startYear && endYear) {
    if (startYear > endYear) {
      return Promise.reject("Start year cannot be later than end year");
    }
    
    if (startYear === endYear && startMonth && endMonth && startMonth > endMonth) {
      return Promise.reject("Start month cannot be later than end month");
    }
  }

  // Validate against previous experience (if not first)
  if (index > 0) {
    const prevEndMonth = form.getFieldValue(`endmonth${index}`);
    const prevEndYear = form.getFieldValue(`endyear${index}`);
    const prevIsCurrent = isCurrentlyWorking[index - 1];
    
    // Skip if previous experience is marked as current
    if (prevIsCurrent) {
      return Promise.resolve();
    }
    
    if (startYear && prevEndYear) {
      if (startYear < prevEndYear) {
        return Promise.reject("Start date must be after previous experience end date");
      }
      
      if (startYear === prevEndYear && startMonth && prevEndMonth) {
        if (startMonth <= prevEndMonth) {
          return Promise.reject("Start date must be after previous experience end date");
        }
      }
    }
  }
  
  return Promise.resolve();
};

const validateEndDates = (_, value, index) => {
  const startMonth = form.getFieldValue(`startmonth${index + 1}`);
  const startYear = form.getFieldValue(`startyear${index + 1}`);
  const endMonth = form.getFieldValue(`endmonth${index + 1}`);
  const endYear = value;
  const isCurrent = isCurrentlyWorking[index];

  // Skip validation if currently working
  if (isCurrent) {
    return Promise.resolve();
  }

  if (startYear && endYear) {
    if (startYear > endYear) {
      return Promise.reject("End year cannot be earlier than start year");
    }
    
    if (startYear === endYear && startMonth && endMonth && startMonth > endMonth) {
      return Promise.reject("End month cannot be earlier than start month");
    }
  }
  
  // If this isn't the last experience, validate against next experience
  if (index < experienceRowCount - 1) {
    const nextStartMonth = form.getFieldValue(`startmonth${index + 2}`);
    const nextStartYear = form.getFieldValue(`startyear${index + 2}`);
    const nextIsCurrent = isCurrentlyWorking[index + 1];
    
    // Skip if next experience is marked as current
    if (nextIsCurrent) {
      return Promise.resolve();
    }
    
    if (endYear && nextStartYear) {
      if (endYear > nextStartYear) {
        return Promise.reject("End date cannot be later than next experience start date");
      }
      
      if (endYear === nextStartYear && endMonth && nextStartMonth) {
        if (endMonth >= nextStartMonth) {
          return Promise.reject("End date cannot be later than next experience start date");
        }
      }
    }
  }
  
  return Promise.resolve();
};
  return (
    <>
      {/* {!isMobile && ( */}
      <Row className={`${!isMobile ? "mt-7" : "mt-4"}`}>
        <Col lg={12} md={12} className="text-end">
          <div className="spacialtyBo">
            <h3>Experience</h3>
            <Button className="add-btn btn" onClick={duplicateExperienceRow}>
              <img src={addIcon} className="img-fluid"></img> Add Experience
            </Button>
          </div>
        </Col>
      </Row>
      {/* )} */}

      {Array.from({ length: experienceRowCount }).map((_, index) => (
        <Row key={index} className="duplicate_row">
          {index === 0 ? (
            /* Render content for the first row */
            <>{/* Your content for the first row */}</>
          ) : (
            /* Render content for other rows */
            <Col lg={12} md={12} className="text-end">
              <Row>
                <Col lg={12} className="mx-auto">
                  <hr />
                </Col>
              </Row>
              <div className="d-flex justify-content-between spacialtyBo">
                <h3>Experience</h3>
                <button>
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    onClick={deleteExperienceRow}
                    className="img-fluid delete"
                  />
                </button>
              </div>
            </Col>
          )}

          <Col lg={6} md={6} className="selectBox ">
            <Form.Item
              name={`designation${index + 1}`}
              label="Designation*"
              rules={[
                {
                  required: true,
                  message: "Designation is required",
                },
              ]}
            >
              <Select placeholder="Please select">
                {designations?.map((item, index) => (
                  <Option key={index} value={item?.id}>
                    {" "}
                    {item?.name}{" "}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col lg={6} md={6} className="selectBox instituteBox">
            <Form.Item
              name={`institute_exp${index + 1}`}
              label="Institute / University* "
              rules={[
                {
                  required: true,
                  message: "Institute is required",
                },
              ]}
            >
              <Select
                placeholder="Please select"
                showSearch
                filterOption={(input, option) =>
                  option.children?.[1]
                    ?.toLowerCase()
                    .startsWith(input.toLowerCase())
                }
              >
                {universities?.data?.map((item, index) => (
                  <Option key={index} value={item?.id}>
                    {" "}
                    {item?.name}{" "}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={12} lg={6} md={6} className="selectBox mob-space">
            <label>Start Date</label>
            <Row style={{ rowGap: !isMobile ? "0px" : "12px" }}>
              <Col lg={6} xs={6}>
                <Form.Item
                  name={`startmonth${index + 1}`}
                 rules={[
    {
      required: true,
      message: "Start month is required.",
    },
    { 
      validator: (_, value) => {
        const startYear = form.getFieldValue(`startyear${index + 1}`);
        return validateExperienceDates(_, startYear, index);
      }
    }
  ]}
                >
                  <Select placeholder="Month">
                    {months.map((month) => (
                      <Option key={month.id} value={month.id}>
                        {month.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={6} xs={6}>
                <Form.Item
                  name={`startyear${index + 1}`}
                  // label="Start year*"
                   rules={[
    { required: true, message: "Start year is required" },
    { validator: (_, value) => validateExperienceDates(_, value, index) }
  ]}
                >
                  <Select placeholder="Year">
                    {years?.length > 0 &&
                      years?.map((item) => (
                        <Option key={item} value={item}>
                          {item}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={12} lg={6} md={6} className="selectBox mob-space">
            <label>End Date</label>
            <Row style={{ rowGap: !isMobile ? "0px" : "12px" }}>
              <Col lg={6} xs={6}>
                <Form.Item
                  name={`endmonth${index + 1}`}
                rules={[
    {
      required: !isCurrentlyWorking[index],
      message: "End month is required",
    },
    { 
      validator: (_, value) => {
        const endYear = form.getFieldValue(`endyear${index + 1}`);
        return validateEndDates(_, endYear, index);
      }
    }
  ]}
                >
                  <Select
                    placeholder="Month"
                    disabled={isCurrentlyWorking[index]}
                  >
                    {months.map((month) => (
                      <Option key={month.id} value={month.id}>
                        {month.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={6} xs={6}>
                <Form.Item
                  name={`endyear${index + 1}`}
                  rules={[
    {
      required: !isCurrentlyWorking[index],
      message: "End Year is required",
    },
    { validator: (_, value) => validateEndDates(_, value, index) }
  ]}
                >
                  <Select
                    placeholder="Year "
                    disabled={isCurrentlyWorking[index]}
                  >
                    {years?.length > 0 &&
                      years?.map((item) => (
                        <Option key={item} value={item}>
                          {item}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col
            lg={12}
            md={12}
            className={`checkbox_style ms-auto text-start ${
              isMobile ? "mt-3" : ""
            }`}
          >
            <Checkbox
              onChange={(e) => currentlyWorkingHandler(e, index)}
              checked={isCurrentlyWorking[index]}
            >
              Currently working here
            </Checkbox>
          </Col>
        </Row>
      ))}

      {/* {isBrowser ?( */}
      <Row className="mt-7">
        <Col lg={12} md={12} className="pos_mobile">
          <hr></hr>
          <div className="spacialtyBo">
            <h3 className="text-wrap" style={{ width: "70%" }}>
              Professional Membership / Certification
            </h3>
            <Button className="add-btn btn" onClick={duplicateRowCertificate}>
              <img src={addIcon} className="img-fluid"></img> Add New
            </Button>
          </div>
        </Col>
      </Row>
      {/* ) : null} */}

      {Array.from({ length: rowCertificate }).map((_, indexx) => (
        <Row key={indexx} className="duplicate_row">
          {indexx === 0 ? (
            /* Render content for the first row */
            <>{/* Your content for the first row */}</>
          ) : (
            /* Render content for other rows */
            <Col lg={12} md={12} className={`mob_pos`}>
              <Row>
                <Col lg={12} className="mx-auto">
                  <hr />
                </Col>
              </Row>

              <div className="d-flex justify-content-between spacialtyBo">
                <h3>Professional Membership / Certification</h3>
                <button>
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    onClick={deleteRowCertificate}
                    className="img-fluid delete dd"
                  />
                </button>
              </div>
            </Col>
          )}

          <Col lg={12} md={12} className="selectBox">
            <Form.Item
              name={`membershipcertificate${indexx + 1}`}
              label="Membership"
            >
              <Select
                placeholder="Please select"
                showSearch
                filterOption={(input, option) =>
                  String(option?.children || "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {certifications?.map((item, index) => (
                  <Option key={index} value={item?.id}>
                    {item?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      ))}
    </>
  );
}

export default Experiance;
